'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.saveTokenData = exports.EMAIL_VERIFICATION = exports.USER_CHANGE_PASSWORD_SUCCESS = exports.USER_CHANGE_PASSWORD = exports.GET_USER_DATA_FAIL = exports.GET_USER_DATA_SUCCESS = exports.GET_USERS_SUCCESS = exports.GET_USERS = exports.CREATE_USER_SUCCESS = exports.CREATE_USER = exports.TOKEN_UPDATED = exports.UPDATE_USER = exports.LOGOUT = exports.LOGIN = exports.AUTH_FAIL = exports.AUTH = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.tryLogin = tryLogin;
exports.tokenUpdated = tokenUpdated;
exports.tryRefreshToken = tryRefreshToken;
exports.saveToken = saveToken;
exports.logout = logout;
exports.getUsers = getUsers;
exports.changeUser = changeUser;

var _auth = require('../selectors/auth');

var _constants = require('../constants');

var _requests = require('./requests');

var AUTH = exports.AUTH = 'AUTH';
var AUTH_FAIL = exports.AUTH_FAIL = 'AUTH_FAIL';
var LOGIN = exports.LOGIN = 'LOGIN';
var LOGOUT = exports.LOGOUT = 'LOGOUT';
var UPDATE_USER = exports.UPDATE_USER = 'UPDATE_USER';
var TOKEN_UPDATED = exports.TOKEN_UPDATED = 'TOKEN_UPDATED';
var CREATE_USER = exports.CREATE_USER = 'CREATE_USER';
var CREATE_USER_SUCCESS = exports.CREATE_USER_SUCCESS = 'CREATE_USER_SUCCESS';
var GET_USERS = exports.GET_USERS = 'GET_USERS';
var GET_USERS_SUCCESS = exports.GET_USERS_SUCCESS = 'GET_USERS_SUCCESS';
var GET_USER_DATA_SUCCESS = exports.GET_USER_DATA_SUCCESS = 'GET_USER_DATA_SUCCESS';
var GET_USER_DATA_FAIL = exports.GET_USER_DATA_FAIL = 'GET_USER_DATA_FAIL';

var USER_CHANGE_PASSWORD = exports.USER_CHANGE_PASSWORD = 'USER_CHANGE_PASSWORD';
var USER_CHANGE_PASSWORD_SUCCESS = exports.USER_CHANGE_PASSWORD_SUCCESS = 'USER_CHANGE_PASSWORD_SUCCESS';

var EMAIL_VERIFICATION = exports.EMAIL_VERIFICATION = 'EMAIL_VERIFICATION';
// export const GET = 'SAVE_TOKEN';

function tryLogin(username, password, rememberMe) {
    return function (dispatch, getState) {
        var state = getState();
        var user = state.user;

        user.rememberMe = rememberMe;

        if (state.config.auth.isJWT) {
            dispatch((0, _requests.postApi)((0, _auth.authJWTURL)(state), AUTH, {
                data: {
                    username: username,
                    password: password,
                    grant_type: 'password',
                    scope: 'all'
                },
                asForm: true,
                headers: {
                    Authorization: 'Basic ' + state.config.auth.jwtKey
                },
                success: function success(resp) {
                    processTokenData(state, dispatch, user, resp.body);
                }
            }));
        } else {
            dispatch((0, _requests.getApi)((0, _auth.authURL)(state)(username, password), AUTH, {
                success: function success(resp) {
                    processTokenData(state, dispatch, user, resp.body);
                }
            }));
        }
    };
}

var saveTokenData = exports.saveTokenData = function saveTokenData(data) {
    return function (dispatch, getState) {
        var state = getState();
        var auth = state.config.auth;

        if (!auth) return;

        var tokenData = data;
        if (!('access_token' in tokenData)) {
            var user = state.user;

            tokenData = user;
        } else {
            tokenData = _extends({}, tokenData, {
                token: tokenData.access_token,
                tokenType: tokenData.token_type,
                rememberMe: true
            });
            dispatch(saveToken(tokenData));
        }

        dispatch((0, _requests.getApi)((0, _auth.profileURL)(getState())(), 'GET_USER_DATA'));
        dispatch(tokenUpdated());
    };
};

function processTokenData(state, dispatch, user, tokenData) {
    dispatch(saveToken(_extends({}, tokenData, { rememberMe: user.rememberMe })));

    if (tokenData.expires_in) {
        setTimeout(function () {
            dispatch(tryRefreshToken(tokenData.refresh_token));
        }, tokenData.expires_in * 0.9 * 1000);
    }

    dispatch((0, _requests.getApi)((0, _auth.profileURL)(state)(), 'GET_USER_DATA', {
        headers: {
            'Authorization': tokenData.token_type + ' ' + tokenData.access_token
        },
        isJWT: state.config.isJWT
    }));
    dispatch(tokenUpdated());
}

function tokenUpdated() {
    return { type: TOKEN_UPDATED };
}

function tryRefreshToken(refreshToken) {
    return function (dispatch, getState) {
        var state = getState();
        var user = state.user;


        dispatch((0, _requests.getApi)((0, _auth.refreshURL)(state)(refreshToken), AUTH, {
            actionFail: LOGOUT,
            fail: function fail() {
                dispatch(logout());
            },
            success: function success(resp) {
                processTokenData(state, dispatch, user, resp.body);
            }
        }));
    };
}

function saveToken(_ref) {
    var access_token = _ref.access_token,
        refresh_token = _ref.refresh_token,
        rememberMe = _ref.rememberMe,
        scope = _ref.scope,
        token_type = _ref.token_type;

    if (!rememberMe) localStorage.setItem(_constants.TOKEN_DATA_STORAGE_KEY, null);else {
        var data = {
            token: access_token,
            tokenType: token_type,
            refreshToken: refresh_token,
            rememberMe: rememberMe
        };
        localStorage.setItem(_constants.TOKEN_DATA_STORAGE_KEY, JSON.stringify(data));
    }
    return {
        type: UPDATE_USER,
        payload: { token: access_token, refreshToken: refresh_token, scope: scope, tokenType: token_type }
    };
}

function logout() {
    localStorage.setItem(_constants.TOKEN_DATA_STORAGE_KEY, null);
    window.location.reload();
    return { type: LOGOUT };
}

function getUsers() {
    return function (dispatch, getState) {
        var state = getState();
        var user = state.user;


        dispatch((0, _requests.getApi)((0, _auth.usersListURL)(state)(), GET_USERS, {
            headers: {
                'Authorization': user.tokenType + ' ' + user.token
            }
        }));
    };
}

function changeUser(newData, callback) {
    return function (dispatch, getState) {
        var state = getState();
        var user = state.user;


        dispatch((0, _requests.patchApi)((0, _auth.profileURL)(state)(user.id || 'me'), USER_CHANGE_PASSWORD, {
            headers: {
                'Authorization': user.tokenType + ' ' + user.token
            },
            data: newData,
            success: function success(resp, next) {
                callback({ ok: true, dispatch: dispatch });
            },
            fail: function fail(resp, next) {
                callback({ ok: false, dispatch: dispatch });
            }
        }));
    };
}
//# sourceMappingURL=user.js.map


//////////////////
// WEBPACK FOOTER
// ./~/perx-uikit/dist/actions/user.js
// module id = 158
// module chunks = 5